import { SuppressionModels } from '../../Enums';

export default class Suppression {
    type: string;
    constructor(type: SuppressionModels) {
      this.type = type;
    }
}
